import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  checkInvitationComptable,
  setPasswordComptable,
  loginComptable,
} from "../services/LoginService";
import { setAuthComptable } from "../Redux/authComptableSlice";
import imgLogin from "../assets/imgLogin1.png";
import { useLocation } from "react-router-dom";

const LoginComptable = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authComptable || {});

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [code, setCode] = useState(""); // récupéré depuis URL
  const [firstLogin, setFirstLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Redirection si déjà connecté
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const codeFromURL = queryParams.get("code");
    if (!codeFromURL) {
      // si pas de code dans l'URL, redirection vers /
      navigate("/");
    } else {
      setCode(codeFromURL);
    }
  }, [location, navigate]);
  useEffect(() => {
    if (auth.isAuthenticated && auth.token) {
      navigate("/EspaceCompta");
    }
  }, [auth, navigate]);

  // Step 1 : Vérifier l'email
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");

    if (!email) {
      setErrorMessage("Veuillez entrer votre email.");
      setLoading(false);
      return;
    }

    try {
      const invitationResponse = await checkInvitationComptable(email, code);

      if (!invitationResponse.success) {
        // Si le code ou email est invalide → afficher message spécifique
        setErrorMessage(
          invitationResponse.message || "Email ou code d'invitation invalide."
        );
        setLoading(false);

        return;
      }

      // L'utilisateur existe et le code est correct
      setFirstLogin(invitationResponse.needs_password);
      setStep(2);

    } catch (error) {
      setErrorMessage(error.message || "Erreur inattendue.");
    }

    setLoading(false);
  };


  // Step 2 : mot de passe
  // Step 2 : mot de passe
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");

    if (!password || (firstLogin && !confirmPassword)) {
      setErrorMessage("Veuillez remplir tous les champs.");
      setLoading(false);
      return;
    }

    if (firstLogin && password !== confirmPassword) {
      setErrorMessage("Les mots de passe ne correspondent pas.");
      setLoading(false);
      return;
    }

    try {
      let response;

      if (firstLogin) {
        // Définir le mot de passe pour la première connexion
        response = await setPasswordComptable(email, code, password, confirmPassword);

        if (response.success) {
          // Après création du mot de passe, connexion automatique avec le code
          response = await loginComptable(email, password, code);
        }
      } else {
        // Login normal, passer aussi le code pour validation
        response = await loginComptable(email, password, code);
      }

      if (response.success) {
        dispatch(setAuthComptable({ token: response.token, email }));
        navigate("/EspaceCompta");
      } else {
        setErrorMessage(response.message || "Échec de la connexion.");
      }
    } catch (error) {
      setErrorMessage(error.message || "Erreur inattendue.");
    }

    setLoading(false);
  };





  return (
    <div className="flex flex-col lg:flex-row w-screen min-h-screen max-h-screen overflow-hidden">
      {/* IMAGE LG */}
      <div className="hidden lg:block lg:w-1/2 relative h-screen">
        <div
          className="absolute inset-0 bg-center bg-cover"
          style={{ backgroundImage: `url(${imgLogin})` }}
        />
        <div className="absolute inset-0 bg-black opacity-40" />
      </div>

      {/* FORMULAIRE */}
      <div className="w-full lg:w-1/2 flex justify-center items-center min-h-screen bg-color2">
        <div className="w-full max-w-lg bg-white p-8 rounded-2xl shadow-lg flex flex-col gap-4">
          <h1 className="text-3xl lg:text-4xl font-bold text-blue-800 w-full text-left">
            Connexion à l'espace Comptable {/* <-- nouveau titre */}
          </h1>
          <p className="text-sm lg:text-base text-blue-700 w-full text-left">
            Connectez-vous pour gérer votre espace comptable.
          </p>

          {errorMessage && (
            <div className="bg-red-100 text-red-600 text-sm p-2 rounded">
              {errorMessage}
            </div>
          )}

          {/* STEP 1 : EMAIL */}
          {step === 1 && (
            <form onSubmit={handleEmailSubmit} className="flex flex-col gap-3 w-full">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="w-full px-3 py-2 text-black text-sm rounded-lg border border-color3 focus:border-color1 outline-none transition"
              />
              <button
                type="submit"
                disabled={loading}
                className="mx-auto w-1/2 bg-blue-800 text-white font-semibold py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
              >
                {loading ? "Vérification..." : "Suivant"}
              </button>
            </form>
          )}

          {/* STEP 2 : PASSWORD */}
          {step === 2 && (
            <form onSubmit={handlePasswordSubmit} className="flex flex-col gap-3 w-full">
              {/* Mot de passe avec eye icon */}
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Mot de passe"
                  className="w-full px-3 py-2 text-black text-sm rounded-lg border border-color3 focus:border-color1 outline-none transition"
                />
                <span
                  className="absolute right-3 top-2/4 transform -translate-y-1/2 cursor-pointer text-gray-500"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "🙈" : "👁️"} {/* emoji eye / hide */}
                </span>
              </div>

              {/* Confirmer mot de passe si premier login */}
              {firstLogin && (
                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirmer le mot de passe"
                    className="w-full px-3 py-2 text-black text-sm rounded-lg border border-color3 focus:border-color1 outline-none transition"
                  />
                  <span
                    className="absolute right-3 top-2/4 transform -translate-y-1/2 cursor-pointer text-gray-500"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? "🙈" : "👁️"}
                  </span>
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="mx-auto w-1/3 bg-blue-800 text-white font-semibold py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
              >
                {loading ? "Connexion..." : firstLogin ? "Valider" : "Se connecter"}
              </button>
            </form>
          )}
        </div>
      </div>



    </div>
  );
};

export default LoginComptable;
